<template>
  <!-- eslint-disable vue/no-multiple-template-root -->
  <!-- <div
    v-if="isError"
    class="container"
  >
    <p>Error</p>
  </div> -->
  <div
    class="container"
  >
    <!-- <div
      v-if="isLoading"
      class="cardlist__wrapper"
    >
      <div class="cardlist__item">
        <CardPlaceHolder />
      </div>
    </div> -->
    <div

      class="cardlist__wrapper"
    >
      <FilterBar
        :categories="categories"
        @emitCategoryId="getCategoryId"
      />
      <div v-if="isLoading">
        <div class="cardlist__container">
          <div
            v-for="i in 6"
            :key="i"
            class="cardlist__items"
          >
            <CardPlaceHolder />
          </div>
        </div>
      </div>
      <div v-else-if="filteredPosts.length === 0">
        <p>{{ errorMessage }}</p>
      </div>
      <div v-else>
        <div
          v-if="filteredPosts.length"
          class="cardlist"
        >
          <div class="cardlist__container">
            <div
              v-for="post in filteredPosts"
              :key="post.id"
              class="cardlist__items"
            >
              <CardItem
                :title="post.title.rendered"
                :thumbnail="getThumbnail(post.acf.featured_image)"
                :preview="getPreview(post.acf.featured_image)"
                :url="post.link"
                :black-bg="post.acf.black_bg"
                :share-to-twitter="encodeURIComponent(post.link)"
                :has-description="post.acf.description.length"
                :media-link="post.acf.media_link"
                :embedded-media="post.acf.embedded_media"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import axios from 'axios'
import FilterBar from './components/FilterBar.vue'
import CardItem from './components/CardItem.vue'
import CardPlaceHolder from './components/CardPlaceHolder.vue'
export default {
  name: 'CardList',
  components: {
    FilterBar,
    CardItem,
    CardPlaceHolder
  },
  data () {
    return {
      posts: [],
      isLoading: true,
      errorMessage: 'No Posts',
      category: 0,
      page: 1,
      totalPage: 0,
      categories: []
    }
  },
  computed: {
    filteredPosts () {
      if (this.category === 0) {
        return this.posts
      } else {
        return this.posts.filter((post) =>
          post.categories.find((catId) => catId === this.category)
        )
      }
    }

  },

  async mounted () {
    this.getCategories()
    // this.getTotalPages()
    this.getPosts()

    // window.addEventListener('scroll', this.scrolling)
  },
  methods: {
    getPreview (postPreview) {
      // console.log(postPreview.url)
      return postPreview.url
    },
    getThumbnail (postThumbnail) {
      // console.log(postThumbnail)
      if (postThumbnail.sizes !== undefined) {
        // console.log(postThumbnail.medium)
        return postThumbnail.sizes.medium
      } else {
        return postThumbnail.url
      }
    },
    getCategories () {
      axios({
        method: 'get',
        url: '/wp-json/wp/v2/categories'

      })
        .then((res) => {
          this.categories.push({ id: 0, name: 'All' })
          res.data.map((category) => {
            return this.categories.push(category)
          })
        })
        .catch(() => {
          this.categories = []
        })
    },
    getCategoryId (categoryId) {
      this.category = categoryId
    },
    // scrolling () {
    //   if (window.innerHeight + document.documentElement.scrollTop === document.documentElement.offsetHeight) {
    //     if (this.page < this.totalPage) {
    //       this.page = this.page + 1
    //       // page++
    //       // console.log(page)
    //       this.getPosts()
    //     }
    //   }
    //   // console.log(window.innerHeight + document.documentElement.scrollTop, document.body.offsetHeight)
    // },
    // getTotalPages () {
    //   axios({
    //     methods: 'GET',
    //     url: '/wp-json/wp/v2/posts'
    //   }).then(res => { this.totalPage = parseInt(res.headers['x-wp-totalpages']) })
    //     .catch(err => console.log(err))
    // },
    async getPosts () {
      await axios({
        methods: 'GET',
        url: '/wp-json/wp/v2/posts'
      }).then(res => { this.totalPage = parseInt(res.headers['x-wp-totalpages']) })
        .catch(() => { this.isLoading = false })

      // console.log(this.totalPage)
      if (this.totalPage !== 0) {
        for (let index = 1; index <= this.totalPage; index++) {
          await axios({
            methods: 'GET',
            url: '/wp-json/wp/v2/posts?order=desc&per_page=10&page=' + index

          })
            .then((res) => {
              res.data.map(item => {
                // console.log(item)
                return this.posts.push(item)
              })

              this.isLoading = false
            })
            .catch(() => {
              // console.log(err.message)
              // this.isError = true
              this.isLoading = false
              this.errorMessage = 'Something went wrong'
            })
        }
      } else {
        this.isLoading = false
        this.errorMessage = 'No Posts'
      }
    }

  }
}
</script>

<style lang="scss" scoped>
/******************
 *
 * Cardlist
 *
******************/

.cardlist {
  &__container {
    display: grid;

    grid-template-columns: repeat(auto-fit, minmax(auto, 342px));
    grid-column-gap: 67px;
    grid-row-gap: 60px;
    grid-auto-flow: row;
    justify-content: center;
  }
}
</style>
